import _extends from 'babel-runtime/helpers/extends';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import cx from 'classnames';
import noop from 'lodash/noop';
import isNil from 'lodash/isNil';
import ArrowUp from '@wh/svg-icons/ArrowUpSlim';
import ArrowDown from '@wh/svg-icons/ArrowDownSlim';

import Portal from '../Portal';
import Dropdown from './SelectDropdown';
import SelectOptionInternal from './SelectOptionInternal';
import { getAllowedAttributes } from '../props-filters';
import { GO, KEYCODES, renderNativeOptions, initiallySelectedIdx, findAnotherOption, splitToSelectEntries, commonPropTypes } from './helpers';

import * as style from './Select.style';

var SelectCustom = function (_Component) {
  _inherits(SelectCustom, _Component);

  function SelectCustom(props, context) {
    _classCallCheck(this, SelectCustom);

    var _this = _possibleConstructorReturn(this, (SelectCustom.__proto__ || _Object$getPrototypeOf(SelectCustom)).call(this, props, context));

    _initialiseProps.call(_this);

    var children = splitToSelectEntries(props.children);
    _this.childrenElements = children.elements;
    _this.childrenValues = children.values;
    _this.childrenLabels = children.labels;

    var initialSelectedIdx = initiallySelectedIdx(_this.childrenValues, isNil(props.value) ? props.defaultValue : props.value);

    _this.state = {
      open: false,
      focused: false,
      selectedIdx: initialSelectedIdx,
      focusedIdx: initialSelectedIdx,
      dropdownVisible: false
    };
    return _this;
  }

  _createClass(SelectCustom, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextValue = nextProps.value;


      if (nextProps.children !== this.props.children) {
        var children = splitToSelectEntries(nextProps.children);
        this.childrenElements = children.elements;
        this.childrenValues = children.values;
        this.childrenLabels = children.labels;
      }

      if (nextValue !== this.props.value && nextValue != null) {
        var valueIdx = this.childrenValues.indexOf(nextValue);
        if (valueIdx === -1) return;
        this.selectOption(valueIdx, true);
      }
    }

    /* eslint-disable complexity */

    /* eslint-enable complexity */

  }, {
    key: 'render',


    /* eslint-disable-next-line complexity */
    value: function render() {
      var _props = this.props,
          defaultValue = _props.defaultValue,
          value = _props.value,
          className = _props.className,
          disabled = _props.disabled,
          onBlur = _props.onBlur,
          onFocus = _props.onFocus,
          onClick = _props.onClick,
          onMouseMove = _props.onMouseMove,
          onMouseOut = _props.onMouseOut,
          onMouseOver = _props.onMouseOver,
          onMouseUp = _props.onMouseUp,
          theme = _props.theme,
          size = _props.size,
          status = _props.status,
          zIndex = _props.zIndex,
          placeholder = _props.placeholder,
          restProps = _objectWithoutProperties(_props, ['defaultValue', 'value', 'className', 'disabled', 'onBlur', 'onFocus', 'onClick', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'theme', 'size', 'status', 'zIndex', 'placeholder']);

      var _state = this.state,
          open = _state.open,
          focused = _state.focused,
          selectedIdx = _state.selectedIdx;
      var select = style.select,
          selectValue = style.selectValue,
          selectValueSelected = style.selectValueSelected;


      var allowedAttributes = getAllowedAttributes(restProps);

      var classNames = cx(select({ theme: theme, size: size, open: open, focused: focused, status: status, disabled: disabled }), className);

      var valueClassName = cx(selectValue, _defineProperty({}, selectValueSelected, selectedIdx !== -1));

      return React.createElement(
        'div',
        _extends({
          className: classNames,
          tabIndex: disabled ? -1 : 0,
          onMouseDown: this.toggleOpen,
          onKeyDown: this.handleKeyDown,
          ref: this.storeSelectRef,
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onClick: onClick,
          onMouseMove: onMouseMove,
          onMouseOut: onMouseOut,
          onMouseOver: onMouseOver,
          onMouseUp: onMouseUp,
          role: 'listbox'
        }, allowedAttributes),
        React.createElement(
          'span',
          { 'data-test-id': 'SelectCustom__value', className: valueClassName },
          this.childrenLabels[selectedIdx] || placeholder || defaultValue || value
        ),
        open ? React.createElement(ArrowUp, null) : React.createElement(ArrowDown, null),
        open && React.createElement(
          Portal,
          null,
          React.createElement(
            Dropdown,
            {
              'data-test-id': 'SelectCustom__dropdown',
              parent: this.selectNode,
              onCloseRequest: this.toggleOpen,
              onShow: this.onDropdownShown,
              onFocusNextRequest: this.onFocusNextRequest,
              onFocusPrevRequest: this.onFocusPrevRequest,
              theme: theme,
              zIndex: zIndex
            },
            this.renderOptions()
          )
        ),
        this.renderNativeSelect()
      );
    }
  }]);

  return SelectCustom;
}(Component);

SelectCustom.propTypes = commonPropTypes;
SelectCustom.defaultProps = {
  disabled: false
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.focus = function () {
    if (_this2.selectNode) _this2.selectNode.focus();
  };

  this.storeSelectRef = function (node) {
    _this2.selectNode = node;
  };

  this.storeNativeSelectRef = function (node) {
    _this2.nativeSelectNode = node;
  };

  this.handleKeyDown = function (e) {
    var keyCode = e.keyCode;


    switch (keyCode) {
      case KEYCODES.SPACE:
      case KEYCODES.ENTER:
        _this2.toggleOpen(e);
        break;
      case KEYCODES.ARROW_DOWN:
        _this2.selectAnother(e, GO.DOWN);
        break;
      case KEYCODES.ARROW_UP:
        _this2.selectAnother(e, GO.UP);
        break;
      default:
        break;
    }
  };

  this.handleFocus = function (e) {
    _this2.setState({ focused: true });
    var onFocus = _this2.props.onFocus;

    if (onFocus) onFocus(e);
  };

  this.handleBlur = function (e) {
    _this2.setState({ focused: false });
    var onBlur = _this2.props.onBlur;

    if (onBlur) onBlur(e);
  };

  this.toggleOpen = function (e) {
    var _props$onMouseDown = _this2.props.onMouseDown,
        onMouseDown = _props$onMouseDown === undefined ? noop : _props$onMouseDown;

    onMouseDown(e);

    if (_this2.props.disabled) return;

    e.stopPropagation();
    e.preventDefault();

    _this2.selectNode.focus();
    _this2.setState({
      open: !_this2.state.open,
      focusedIdx: _this2.state.selectedIdx,
      dropdownVisible: _this2.state.open ? false : _this2.state.dropdownVisible
    });
  };

  this.createOnSelected = function (idx) {
    return function (e) {
      _this2.selectOption(idx);
      _this2.toggleOpen(e);
    };
  };

  this.focusAnother = function (dir) {
    return function (e) {
      e.preventDefault();
      var focusedIdx = _this2.state.focusedIdx;

      var newIdx = findAnotherOption(dir, focusedIdx, _this2.childrenElements);
      _this2.focusOption(newIdx);
    };
  };

  this.onFocusNextRequest = this.focusAnother(GO.DOWN);
  this.onFocusPrevRequest = this.focusAnother(GO.UP);

  this.selectAnother = function (e, dir) {
    var _state2 = _this2.state,
        selectedIdx = _state2.selectedIdx,
        open = _state2.open;

    if (open) return;

    e.preventDefault();
    e.stopPropagation();
    var newIdx = findAnotherOption(dir, selectedIdx, _this2.childrenElements);
    _this2.selectOption(newIdx);
  };

  this.selectOption = function (idx, noTrigger) {
    var selectedIdx = _this2.state.selectedIdx;

    if (idx === selectedIdx) return;

    _this2.setState({ selectedIdx: idx }, function () {
      if (noTrigger) return;
      var changeEvent = new Event('change', { bubbles: true, cancelable: true });
      _this2.nativeSelectNode.dispatchEvent(changeEvent);
    });
  };

  this.focusOption = function (idx) {
    return _this2.setState({ focusedIdx: idx });
  };

  this.renderNativeSelect = function () {
    var _props2 = _this2.props,
        defaultValue = _props2.defaultValue,
        value = _props2.value,
        onChange = _props2.onChange,
        onSubmit = _props2.onSubmit,
        disabled = _props2.disabled,
        name = _props2.name,
        required = _props2.required,
        placeholder = _props2.placeholder;
    var selectedIdx = _this2.state.selectedIdx;
    var selectControl = style.selectControl,
        selectControlReadOnly = style.selectControlReadOnly;

    var className = cx(selectControl, selectControlReadOnly);

    return React.createElement(
      'select',
      {
        'data-test-id': 'SelectCustom__select',
        className: className,
        value: _this2.childrenValues[selectedIdx] || defaultValue || value,
        ref: _this2.storeNativeSelectRef,
        name: name,
        tabIndex: '-1',
        disabled: disabled,
        onChange: onChange,
        onSubmit: onSubmit,
        required: required
      },
      React.createElement(
        'option',
        { value: '' },
        placeholder || ''
      ),
      renderNativeOptions(_this2.childrenElements, _this2.childrenLabels)
    );
  };

  this.renderOptions = function () {
    var _state3 = _this2.state,
        selectedIdx = _state3.selectedIdx,
        focusedIdx = _state3.focusedIdx,
        dropdownVisible = _state3.dropdownVisible;
    var size = _this2.props.size;


    return _this2.childrenElements.map(function (_ref, idx) {
      var props = _ref.props;
      return React.createElement(SelectOptionInternal, _extends({}, props, {
        key: props.value,
        size: size,
        'data-test-id': 'SelectCustom__dropdown-option--' + idx,
        onSelectRequest: _this2.createOnSelected(idx),
        selected: selectedIdx === idx,
        focus: dropdownVisible && focusedIdx === idx
      }));
    });
  };

  this.onDropdownShown = function () {
    _this2.setState({ dropdownVisible: true });
  };
};

export default SelectCustom;